// Copyright (c) Bentley Systems

export class ConfigManager {
  private static _baseUrl: any;

  public static getBaseUrl(): any {
    const redirectUrl = new URL(`${window.location.origin}/signin-callback`);

    ConfigManager._baseUrl = redirectUrl;
    return ConfigManager._baseUrl;
  }

  public static edfsUrl = (window.env?.VITE_EDFS_ITWIN_URL ??
    import.meta.env.VITE_EDFS_ITWIN_URL) as string;

  public static iTwinPlatformUrl = (window.env?.VITE_ITWIN_PLATFORM_URL ??
    import.meta.env.VITE_ITWIN_PLATFORM_URL) as string;

  public static edfsItwinInternalUrl = (window.env
    ?.VITE_EDFS_ITWIN_INTERNAL_URL ??
    import.meta.env.VITE_EDFS_ITWIN_INTERNAL_URL) as string;

  public static edfsCoreItwinInternalUrl = (window.env
    ?.VITE_EDFS_ITWIN_INTERNAL_URL ??
    import.meta.env.VITE_EDFS_ITWIN_INTERNAL_URL) as string;

  public static edfsLegacyUrl = (window.env?.VITE_EDFS_LEGACY_URL ??
    import.meta.env.VITE_EDFS_LEGACY_URL ??
    ConfigManager.edfsItwinInternalUrl) as string;

  public static projectProviderUrl = (window.env
    ?.VITE_EDFS_PROJECT_PROVIDER_URL ??
    import.meta.env.VITE_EDFS_PROJECT_PROVIDER_URL) as string;

  public static isProjectVariableValidationEnabled =
    (window.env?.VITE_PROJECT_VARIABLE_VALIDATION_ENABLED ??
      import.meta.env.VITE_PROJECT_VARIABLE_VALIDATION_ENABLED) === "true";

  /**
   * Removes `/edfs` from the URL if `edfsUrl` is different from `iTwinPlatformUrl` (R&D).
   * @param path - The URL path to process.
   * @returns The modified path with `/edfs` removed if `edfsUrl` differs from `iTwinPlatformUrl`.
   */
  public static removeEdfsIfNeeded(path: string): string {
    if (ConfigManager.edfsUrl !== ConfigManager.iTwinPlatformUrl) {
      path = path.replace(/^\/edfs/, "");
    }
    return path;
  }
}
